import { GodRays } from '@paper-design/shaders-react'
import { cn } from '~/lib/utils'

export default function GodRaysBackground({
  className,
  backgroundColor,
  colors,
  colorBloom,
  bloom = 1,
  offsetX,
  offsetY,
  midSize = 1.5,
  midIntensity = 1.2,
  speed = 0.75,
  intensity = 0.25,
  density = 0.5,
}: {
  className?: string
  backgroundColor?: string
  colors?: string[]
  colorBloom?: string
  bloom?: number
  offsetX?: number
  offsetY?: number
  midSize?: number
  midIntensity?: number
  speed?: number
  intensity?: number
  density?: number
}) {
  return (
    <GodRays
      className={cn('absolute! inset-0 z-0 transform-gpu', className)}
      colorBack={backgroundColor}
      colors={colors}
      offsetX={offsetX}
      offsetY={offsetY}
      midSize={midSize}
      midIntensity={midIntensity}
      density={density}
      intensity={intensity}
      speed={speed}
      fit="cover"
      colorBloom={colorBloom}
      bloom={bloom}
    />
  )
}
